import { createFileRoute } from "@tanstack/react-router";
import { WelcomePage } from "@/pages/Welcome/WelcomePage";
import { requireSession } from "../shell-handle/bootGate";

export const Route = createFileRoute("/welcome")({
  beforeLoad: () => requireSession(),
  component: WelcomePage,
});
